import type { JourneySectionProgress } from "./journey-sections";

/**
 * Generate contextual assessment copy based on how many journey sections are complete.
 */
export function buildAssessmentText(sections: JourneySectionProgress[]): string {
  const completedCount = sections.filter((s) => s.status === "complete").length;

  if (completedCount === 0) return "Answer a few questions to see your treatment recommendation.";
  if (completedCount === 1)
    return "Great start. Keep going to unlock your personalized recommendation.";
  if (completedCount <= 3)
    return "Based on what you've shared so far, you're on track for a personalized recommendation.";
  return "Your profile is complete. Your personalized recommendation is ready.";
}
